<template>
	<div>
		<!-- breadcrumb area -->
		<div class="breadcrumb-area breadcrumb-padding bg-img" :style="{backgroundImage:`url(${bgImg})`}">
		    <div class="container">
		        <div class="breadcrumb-content text-center">
		            <h2>展会</h2>
		        </div>
		    </div>
		</div>
		<!-- Project area -->
		<div class="section section-padding">
		    <div class="container">
		        <div class="row row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6">
		            <div class="col mb-6" v-for="(item,index) in exhibitionList" :key="item.id">
		                <div class="blog-wrap">
		                    <div class="blog-img mb-2">
								<router-link :to="{path:'/exhibitionDetail/'+item.id}"><img :src="item.image | imgfilter" alt=""></router-link>
		                    </div>
		                    <div class="blog-content">
		                        <router-link :to="{path:'/exhibitionDetail/'+item.id}"><div>{{item.name}}</div></router-link>
		                    </div>
		                </div>
		            </div>
		        </div> 
		        <div class="pagination-style mt-lg-9 mt-md-7 mt-5">
					<div class="block">
					    <el-pagination
					      @current-change="handleCurrentChange"
						  :pager-count="5"
					      :current-page="currentPage"
					      layout="total, prev, pager, next"
					      :total="total">
					    </el-pagination>
					  </div>
		        </div>
		    </div>
		</div>
		
	</div>
</template>

<script>
	import { getCookies, removeCookies } from '@/libs/util'
	import { getExhibitionList } from '@/api'
	export default {
	    data() {
	      return {
			  nameInfo: '',
			bgImg: require('../static/images/banner/banner-3.jpg'),
			exhibitionList: [],
	        currentPage: 1,
			total: 0,
	      };
	    },
		created() {
			this.getExhibitionList()
		},
		computed: {
			isLogin() {
			  return getCookies("webtoken");
			},
		},
		methods: {
			
			// 获取分类案例列表
			async getExhibitionList() {
			  const res = await getExhibitionList({
				  page: this.currentPage,
				  limit: 9
			  })
			  this.total = res.data.count
			  this.exhibitionList = res.data.list 
			},
			// 页码跳转
			handleCurrentChange(val) {
				this.currentPage = val
				this.getExhibitionList()
				document.documentElement .scrollTop= 0
			},
		  
		},
	}
	
</script>

<style>
	.stick {
	  -webkit-animation: 700ms ease-in-out 0s normal none 1 running fadeInDown;
	          animation: 700ms ease-in-out 0s normal none 1 running fadeInDown;
	  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1);
	  position: fixed;
	  top: 0;
	  width: 100%;
	  z-index: 999;
	  left: 0;
	  background-color: #ffffff;
	  transition: all 0.3s ease 0s;
	}
</style>
